<template>
  <div class="sing-up">
    <div class="sing-up__bg sing-up__bg_1 _ibg-contain">
      <img src="@/assets/img/bg/hero/01.png" />
    </div>
    <div class="sing-up__bg sing-up__bg_2 _ibg-contain">
      <img src="@/assets/img/bg/hero/02.png" />
    </div>
    <div class="sing-up__bg sing-up__bg_3 _ibg">
      <img src="@/assets/img/bg/hero/03.png" />
    </div>
    <div class="sing-up__bg sing-up__bg_4 _ibg-contain">
      <img src="@/assets/img/bg/hero/04.png" />
    </div>
    <div class="sing-up__inner _cnt">
      <div class="sing-up__content">
        <div class="sing-up__title _h1">{{ $t("Registration") }}</div>
        <div class="sing-up__line _line"><span></span></div>
        <div class="sing-up__form">
          <BaseInput
            class="sing-up__input"
            v-model="name"
            type="text"
            :label="`${$t('First name')}:`"
          />
          <BaseInput
            class="sing-up__input"
            v-model="surname"
            type="text"
            :label="`${$t('Last name')}:`"
          />
          <BaseInput
            class="sing-up__input"
            v-model="email"
            type="email"
            :label="`${$t('Email')}:`"
          />
          <BaseInput
            class="sing-up__input"
            v-model="phone"
            type="tel"
            :label="`${$t('Phone number')}:`"
          />
          <BaseInput
            class="sing-up__input"
            v-model="pass"
            type="password"
            :label="`${$t('Password')}:`"
          />
          <BaseInput
            class="sing-up__input"
            v-model="passConfirm"
            type="password"
            :label="`${$t('Confirm Password')}:`"
          />
        </div>
        <BaseTermCheckbox v-model="terms" class="sing-up__checkbox">
          {{ $t("I confirm that I have read, understood, and agree to the") }}
          <router-link
            v-if="termsPage && termsPage.slug"
            :to="{ name: 'TextPage', params: { slug: termsPage.slug } }"
            class="desc small"
            target="_blank"
          >
            {{ termsPage.title }}
          </router-link>

          <template v-if="termsPage && privacyPage">
            <span class="desc small"> {{ " " + $t("and") + " " }} </span>
            <router-link
              v-if="privacyPage && privacyPage.slug"
              :to="{ name: 'TextPage', params: { slug: privacyPage.slug } }"
              class="desc small"
              target="_blank"
            >
              {{ privacyPage.title }}
            </router-link>
          </template>
          I also confirm that I am at least 18 years old.
        </BaseTermCheckbox>
        <Transition>
          <p v-if="error" class="sing-up__error">
            {{ error }}
          </p>
        </Transition>
        <BaseButton
          :text="loaderIsVisible ? `${$t('Registrating')}...` : $t('Register')"
          :disabled="!requiredRegisterFieldsAreFilled || isSubmitting"
          @click="submitRegister"
          class="sing-up__submit _btn-primary"
        />

        <div class="sing-up__bottom">
          <p class="sing-up__text">{{ $t("Already have an account?") }}</p>
          <router-link class="sing-up__link-up _btn-bordered" to="/signin">
            {{ $t("Log in") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/base/BaseButton.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseTermCheckbox from "@/components/base/BaseTermCheckbox.vue";
import { PRIVACY_PAGE, TERMS_PAGE } from "@/store/modules/staticPages";
import { mapGetters } from "vuex";

export default {
  name: "SignupPage",
  components: {
    BaseButton,
    BaseInput,
    BaseTermCheckbox,
  },
  isAuth: { type: Boolean, required: true },
  props: {
    error: {
      type: String,
      required: true,
    },
    loaderIsVisible: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      isSubmitting: false,
      email: "",
      pass: "",
      name: "",
      surname: "",
      phone: "",
      passConfirm: "",
      terms: false,
      countryCode: "",
      phoneFull: "",
      countryOptions: [],
      countryOptionsIso: [],
      dob: null,
      address: "",
      city: "",
      zip: "",
      countryId: "",
      referralCode: "",
    };
  },
  computed: {
    ...mapGetters("staticPages", ["getTermsPage", "getPrivacyPage"]),
    termsPage() {
      return this.getTermsPage;
    },
    privacyPage() {
      return this.getPrivacyPage;
    },
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.email &&
        // this.dob &&
        this.pass &&
        this.passConfirm &&
        this.terms
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  created() {
    this.TERMS_PAGE = TERMS_PAGE;
    this.PRIVACY_PAGE = PRIVACY_PAGE;
  },
  mounted() {
    this.getCountries();
    this.isSubmitting = false;
  },
  watch: {
    isAuth(isNowAuthed) {
      if (isNowAuthed && this.$route.path !== "/profile/personal-information") {
        this.$router.push("/profile/personal-information");
      }
    },
  },
  methods: {
    clearCountry() {
      this.countryId = "";
    },
    phoneDataUpdate(e) {
      this.phoneFull = e.phoneNumber; // Use raw phoneNumber without formatting
    },
    getCountries() {
      this.$http
        .get("countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
          this.countryOptionsIso = res.data.payload.map((obj) => obj.iso);
          this.countryCode = this.countryOptionsIso[0];
        })
        .catch(() => {});
    },
    closeSignUpModal() {
      this.$emit("closeSignIn");
    },
    openSignInModal() {
      this.$emit("openSignIn");
    },
    submitRegister() {
      this.isSubmitting = true;
      let regData = {
        dob: this.dob,
        name: this.name,
        surname: this.surname,
        email: this.email,
        //phone: this.phoneFull,
        phone: this.phone,
        password: this.pass,
        passConfirm: this.passConfirm,
        address: this.address,
        city: this.city,
        zip: this.zip,
        country_id: this.countryId,
        referral_code: this.referralCode,
      };
      this.$emit("registration", regData);
      this.isSubmitting = false;
    },
    showDatePicker() {
      this.$refs.dob.type = "date";
      this.$refs.dob.focus();
    },
    hideDatePicker() {
      if (!this.dob) {
        this.$refs.dob.type = "text";
        this.dob = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/mixins" as *;
@use "@/assets/styles/media" as *;
@use "@/assets/styles/components/classes" as *;

.sing-up {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  @include adaptiveValue("padding-top", 100, 75);
  @include adaptiveValue("padding-bottom", 100, 25);
  position: relative;
  overflow: hidden;
  margin-top: -64px;
  @media (max-width: $md1) {
    margin-top: -50px;
  }
  @media (max-width: $md2) {
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: var(--bg-fifth-color);
    }
    min-height: fit-content;
  }
  &__bg {
    position: absolute;
    &_1 {
      width: 50%;
      left: 0px;
      bottom: 0px;
      padding-bottom: 14.5%;
      z-index: -1;
    }
    &_2 {
      width: 52.5%;
      left: -3.5%;
      bottom: -4%;
      padding-bottom: 41.5%;
      z-index: -2;
    }
    &_3 {
      width: 100%;
      height: 100%;
      left: -38%;
      z-index: -3;
      bottom: 0px;
    }
    &_4 {
      width: 94.5%;
      height: 94%;
      right: 0px;
      top: 10%;
      z-index: -4;
    }
  }
  &__inner {
    flex: 1 1 auto;
    position: relative;
  }
  &__content {
    margin-left: auto;
    position: relative;
    z-index: var(--base-z-index);
    @include adaptiveValue("max-width", 710, 500, 1470, 768, 1);
    @media (max-width: $md3) {
      margin-right: auto;
    }
  }
  &__title,
  &__line {
    text-align: center;
    &:not(:last-child) {
      @include adaptiveValue("margin-bottom", 25, 15);
    }
  }
  &__form {
    &:not(:last-child) {
      @include adaptiveValue("margin-bottom", 20, 15);
    }
  }
  &__input {
    flex: 0 1 50%;
    &:not(:last-child) {
      @include adaptiveValue("margin-bottom", 14, 10);
    }
  }
  &__input-label {
    display: flex;
    justify-content: center;
    font-weight: 500;
    text-transform: capitalize;
    margin-bottom: 5px;
  }
  &__link {
    width: fit-content;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    &:not(:last-child) {
      @include adaptiveValue("margin-bottom", 40, 20);
    }
  }
  &__checkbox {
    &:not(:last-child) {
      @include adaptiveValue("margin-bottom", 20, 15);
    }
  }
  &__error {
    text-align: center;
    margin-bottom: 8px;
    color: var(--error-color);
  }
  &__submit {
    max-width: 220px;
    width: 100%;
    margin: 0 auto;
    &:not(:last-child) {
      @include adaptiveValue("margin-bottom", 72, 20);
    }
  }
  &__bottom {
    @media (min-width: $md4) {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
    }
  }
  &__text {
    font-weight: 500;
    @media (max-width: $md4) {
      text-align: center;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
  &__link-up {
    max-width: 220px;
    width: 100%;
    @media (max-width: $md4) {
      margin: 0 auto;
    }
  }
}

.checkbox {
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  gap: 10px;

  &__input {
    display: none;
  }
  &__checked {
    min-width: 20px;
    height: 20px;
    border: 1px solid var(--primary-color);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    transition: all 0.3s ease 0s;
    position: relative;
    svg {
      width: 12px;
      height: 9px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: opacity 0.3s ease 0s;
      opacity: 0;
      path {
        stroke: var(--third-color);
      }
    }
  }
  &__image {
    position: absolute;
    width: 10px;
    height: 10px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s ease 0s;
    opacity: 0;
  }
  &__input:checked + .checkbox__checked {
    border: 1px solid transparent;
    svg {
      opacity: 1;
    }
  }
  &__input:disabled + .checkbox__checked {
    opacity: 0.5;
  }

  &__text {
    font-weight: 400;
    a {
      color: var(--hint-color);
      transition: color 0.3s ease 0s;
      @media (any-hover: hover) {
        &:hover {
          color: var(--hint-hover-color);
        }
      }
    }
  }
}
</style>
